import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useAppDataStore } from './useAppDataStore';

/**
 * No need to use storeToRefs() on this store because authentication is not reactive
 */
export const useAuthStore = defineStore('auth', () => {
  const appDataStore = useAppDataStore();

  const {
    user,
    isImpersonated,
    organizationUsers,
    impersonatedPipedriveUser,
  } = storeToRefs(appDataStore);

  const isLoggedIn = computed<boolean>(() => !!user.value);

  return {
    user,
    organizationUsers,
    isImpersonated,
    isLoggedIn,
    impersonatedPipedriveUser,
  };
});
